import Vue from 'vue'
import Address from 'src/models/address'
import BaseGeocodeService from '../../baseGeocodeService'
import ResponseCacher from '../../../utils/responseCacher'
import serverConfig from 'src/server_config.js'

const CACHE_RETRIEVALS_BEFORE_CLEAN = 1000
const KEEP_CACHED_MS = 900000 // 15 minutes in ms

class NominatimGeocodeService extends BaseGeocodeService {
  constructor (serviceUrl) {
    super()
    this.serviceUrl = serviceUrl
    this.cache = new ResponseCacher(CACHE_RETRIEVALS_BEFORE_CLEAN, KEEP_CACHED_MS)
  }

  /**
   * Get reversed geocoded address
   *
   * @param {Latitude} latitude
   * @param {Longitude} longitude
   */
  async reverseGeocode (latitude, longitude) {
    const key = `${latitude}${longitude}`

    if (this.cache.isCached(key)) {
      return this.cache.getValue(key)
    }

    const result = (await Vue.http.get(
      `${this.serviceUrl}/reverse`,
      {
        responseType: 'text',
        params: {
          lat: latitude,
          lon: longitude,
          format: 'json',
          zoom: 18,
          polygon: 1
        }
      }
    )).body
    const response = new Address.Builder()
      .setNumber(result.address.house_number)
      .setStreet(result.address.road)
      .setNeighbourhood(result.address.suburb)
      .setCity('city' in result.address ? result.address.city : result.address.town)
      .setState(result.address.state)
      .setCountry(result.address.country)
      .build()

    this.cache.setValue(key, response)

    return response
  }
}

const geocodeService = new NominatimGeocodeService(serverConfig.nominatim_url)
export default geocodeService



// WEBPACK FOOTER //
// ./src/services/geocoding/implementations/nominatim/nominatimGeocodeService.js